import {
  Input,
  Component,
  ElementRef,
  ViewContainerRef,
  booleanAttribute,
  ViewEncapsulation,
  ChangeDetectionStrategy,
} from '@angular/core';

import { LoadingIndicatorComponent } from '@/app/shared/components/ui/loading-indicator';

export type ButtonSize = 'small' | 'medium' | 'large' | 'xlarge';
export type ButtonVariant =
  | 'base'
  | 'primary'
  | 'secondary'
  | 'outlined'
  | 'primary-outlined'
  | 'error'
  | 'primary-text'
  | 'error-filled';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'button[app-button], a[app-button]',
  imports: [LoadingIndicatorComponent],
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[attr.type]': 'type',
    '[attr.disabled]': '_getDisabledAttribute()',
    '[class]': '_getButtonClasses()',
    '[class.button_without-focus]': 'disableFocusStyles',
  },
})
export class ButtonComponent {
  @Input()
  size: ButtonSize = 'medium';

  @Input({ transform: booleanAttribute })
  loading = false;

  @Input({ transform: booleanAttribute })
  disableFocusStyles = false;

  @Input()
  variant: ButtonVariant = 'base';

  @Input({ transform: booleanAttribute })
  disabled = false;

  @Input()
  type: 'submit' | 'button' = 'button';

  constructor(
    public elementRef: ElementRef,
    public viewContainerRef: ViewContainerRef,
  ) {}

  _getDisabledAttribute() {
    return !this.loading && !this.disabled ? null : true;
  }

  _getButtonClasses() {
    return `button button_${this.size} button_${this.variant}`;
  }
}
